import { CUSTOM_CHAT_RESPONSE_COMPONENTS } from './components.js';
import type {
  ChatResponseDefinition,
  ChatResponseDefinitionMap,
  ExternalChatResponseType,
} from './types.js';

const CUSTOM_CHAT_RESPONSE_REGISTRY_MAP: ChatResponseDefinitionMap = {
  'frm-account-search': {
    type: 'frm-account-search',
    label: 'FRM Account Search',
    renderLocation: 'top-level',
    renderInInitialMessage: true,
    component: CUSTOM_CHAT_RESPONSE_COMPONENTS['frm-account-search'],
    textSerializer: ({ response }) => response.value,
    docxCategory: 'static',
    docxSerializer: () => 'Account search results displayed.',
  },
  'rep-territory-insights': {
    type: 'rep-territory-insights',
    label: 'Rep Territory Insights',
    renderLocation: 'top-level',
    renderInInitialMessage: true,
    component: CUSTOM_CHAT_RESPONSE_COMPONENTS['rep-territory-insights'],
    textSerializer: ({ response }) => response.value,
    docxCategory: 'static',
    docxSerializer: () => 'Territory insights displayed.',
  },
  'dm-territory-insights': {
    type: 'dm-territory-insights',
    label: 'DM Territory Insights',
    renderLocation: 'top-level',
    renderInInitialMessage: true,
    component: CUSTOM_CHAT_RESPONSE_COMPONENTS['dm-territory-insights'],
    textSerializer: ({ response }) => response.value,
    docxCategory: 'static',
    docxSerializer: () => 'DM Territory insights displayed.',
  },
  'rep-two-minute-summary': {
    type: 'rep-two-minute-summary',
    label: 'Rep Two Minute Summary',
    renderLocation: 'top-level',
    renderInInitialMessage: true,
    component: CUSTOM_CHAT_RESPONSE_COMPONENTS['rep-two-minute-summary'],
    textSerializer: ({ response }) => response.value,
    docxCategory: 'static',
    docxSerializer: () => 'Rep Two Minute Summary displayed.',
  },
  'dm-hcp-alerts': {
    type: 'dm-hcp-alerts',
    label: 'DM HCP Alerts',
    renderLocation: 'top-level',
    renderInInitialMessage: true,
    component: CUSTOM_CHAT_RESPONSE_COMPONENTS['dm-hcp-alerts'],
    textSerializer: ({ response }) => response.value,
    docxCategory: 'static',
    docxSerializer: () => 'DM HCP Alerts displayed.',
  },
};

export const CUSTOM_CHAT_RESPONSE_REGISTRY = Object.freeze(CUSTOM_CHAT_RESPONSE_REGISTRY_MAP);

export const CUSTOM_CHAT_RESPONSE_TYPES = Object.freeze(
  Object.keys(CUSTOM_CHAT_RESPONSE_REGISTRY) as ExternalChatResponseType[]
);

export const TOP_LEVEL_CUSTOM_CHAT_RESPONSE_TYPES = Object.freeze(
  CUSTOM_CHAT_RESPONSE_TYPES.filter(
    (type) => CUSTOM_CHAT_RESPONSE_REGISTRY[type].renderLocation === 'top-level'
  )
);

export const INITIAL_MESSAGE_CUSTOM_CHAT_RESPONSE_TYPES = Object.freeze(
  CUSTOM_CHAT_RESPONSE_TYPES.filter(
    (type) => CUSTOM_CHAT_RESPONSE_REGISTRY[type].renderInInitialMessage === true
  )
);

export function getCustomChatResponseDefinition(type: string): ChatResponseDefinition | null {
  if (!Object.prototype.hasOwnProperty.call(CUSTOM_CHAT_RESPONSE_REGISTRY, type)) {
    return null;
  }

  return CUSTOM_CHAT_RESPONSE_REGISTRY[type as ExternalChatResponseType];
}
